  import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Skeleton,
  } from "@mui/material";
  import Timeline from "@mui/lab/Timeline";
  import TimelineItem from "@mui/lab/TimelineItem";
  import TimelineSeparator from "@mui/lab/TimelineSeparator";
  import TimelineConnector from "@mui/lab/TimelineConnector";
  import TimelineContent from "@mui/lab/TimelineContent";
  import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
  import TimelineDot from "@mui/lab/TimelineDot";

  // Icons
  import PersonIcon from "@mui/icons-material/Person";
  import BuildCircleIcon from "@mui/icons-material/BuildCircle";
  import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
  import CheckCircleIcon from "@mui/icons-material/CheckCircle";
  import LockIcon from "@mui/icons-material/Lock";
  import FolderOpenIcon from "@mui/icons-material/FolderOpen";


  import NohistoryFound from "./../../img/no-history.png";

  const StatusTimelineDialog = ({
    openTimelineDialog,
    handleTimelineClose,
    selectedTicketId,
    loading,
    history,
  }) => {
    return (
    <Dialog open={openTimelineDialog} onClose={handleTimelineClose} maxWidth="sm" fullWidth>
    <DialogTitle color="primary">Status Ticket: {selectedTicketId}</DialogTitle>
    <DialogContent
      dividers
      sx={{
        maxHeight: "400px",
        overflowY: "auto",
        px: 2,
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Timeline position="alternate">
          {loading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <TimelineItem key={index}>
                <TimelineOppositeContent
                  sx={{ m: "auto 0", minWidth: 100 }}
                  variant="body2"
                  color="text.secondary"
                >
                  <Skeleton width="80%" height={20} />
                </TimelineOppositeContent>

                <TimelineSeparator>
                  <TimelineDot color="grey" />
                  {index < 4 ? (
                    <TimelineConnector />
                  ) : (
                    <Box sx={{ height: 20 }} /> // maintain spacing on last item
                  )}
                </TimelineSeparator>

                <TimelineContent sx={{ py: 2, px: 2 }}>
                  <Skeleton variant="text" width="60%" height={28} />
                  <Skeleton variant="text" width="90%" height={20} />
                </TimelineContent>
              </TimelineItem>
            ))
          ) : history.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 5, width: "100%" }}>
              <img
                src={NohistoryFound}
                alt="No History"
                style={{ width: "200px", marginBottom: 16,height:"200px" }}
              />
              <Typography variant="h6" color="text.secondary">
                No status history found for this ticket.
              </Typography>
            </Box>
          ) : (
            history.map((entry, index) => {
              let Icon;
              let color;

              switch (entry.status) {
                case "Open":
                  Icon = PersonIcon;
                  color = "primary";
                  break;
                case "In Progress":
                  Icon = BuildCircleIcon;
                  color = "info";
                  break;
                case "Escalated":
                  Icon = PriorityHighIcon;
                  color = "warning";
                  break;
                case "Resolved":
                  Icon = CheckCircleIcon;
                  color = "success";
                  break;
                case "Closed":
                  Icon = LockIcon;
                  color = "secondary";
                  break;
                default:
                  Icon = FolderOpenIcon;
                  color = "grey";
              }

              const isLast = index === history.length - 1;

              return (
                <TimelineItem key={entry._id}>
                  <TimelineOppositeContent
                    sx={{ m: "auto 0", minWidth: 100 }}
                    variant="body2"
                    color="text.secondary"
                  >
                    {new Date(entry.changedAt).toLocaleString()}
                  </TimelineOppositeContent>

                  <TimelineSeparator>
                    <TimelineDot color={color}>
                      <Icon />
                    </TimelineDot>
                    {!isLast ? (
                      <TimelineConnector />
                    ) : (
                      <Box sx={{ height: 20 }} />
                    )}
                  </TimelineSeparator>

                  <TimelineContent sx={{ py: 2, px: 2 }}>
                    <Typography variant="h6" component="span">
                      {entry.status}
                    </Typography>
                    <Typography>{entry.comment}</Typography>
                  </TimelineContent>
                </TimelineItem>
              );
            })
          )}
        </Timeline>
      </Box>
    </DialogContent>
  </Dialog>

    );
  };

  export default StatusTimelineDialog;
